import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { givingApi } from '@/api/giving';
import { useTreasure, useFinancialErrors } from './treasureAccess';
import { currentPeriod, periodError, type Period } from './periods';
export function usePeriod() { return useState<Period>(()=>currentPeriod()); }
export function useReport(period: Period) {
  const {churchId,userId,access} = useTreasure();
  const query = useQuery({queryKey:['giving',churchId,'report',userId,period.start,period.end],
    queryFn:()=>givingApi(churchId).report(period.start,period.end),
    enabled:access.enabled && access.permissions.includes('GIVING_SUMMARY_VIEW') && !periodError(period),
    staleTime:120000,gcTime:0,retry:false,refetchOnWindowFocus:false});
  useFinancialErrors(query.error);
  return {...query, data:query.isError?undefined:query.data};
}
